import { PLACEHOLDER_CONTEXT, getPlaceholderTokensForContext } from '@constants/placeholders';
import { escapeRegex } from '@helpers/text-editor';

const SEND_SURVEY_TOKENS = getPlaceholderTokensForContext(PLACEHOLDER_CONTEXT.SEND_SURVEY);

// Tokens with undefined/null values stay as [token] so SurveysQueueConsumer can substitute
// them per recipient. Replacement is a function so `$&`/`$1`/`$$` in values aren't treated
// as String.replace patterns.
export const substitutePlaceholders = (template, values = {}) => {
    if (!template) return '';
    return SEND_SURVEY_TOKENS.reduce((acc, token) => {
        const value = values[token];
        if (value === undefined || value === null) return acc;
        const re = new RegExp(`\\[${escapeRegex(token)}\\]`, 'g');
        return acc.replace(re, () => value);
    }, template);
};

// Live-edit normalizer: removes [link] only. The backend appends the survey URL
// automatically (SurveysQueueConsumer.cs:286), so literal [link] in the body would
// duplicate the hint and leak the token to the recipient.
export const stripLinkToken = text => (text ? text.replace(/\[link\]/g, '') : '');

// Boundary normalizer for template load and submit. Live typing must use stripLinkToken
// only — trimming/space-collapsing every keystroke would eat the user's trailing spaces.
export const normalizeMessageBodyForSend = text => {
    if (!text) return '';
    return stripLinkToken(text).replace(/ {2,}/g, ' ').trim();
};

// `link` isn't substituted by the backend, but stripLinkToken removes it before the
// validator sees it; it's allowed here to cover the one-tick window between keystroke and
// state update.
const ALLOWED_SEND_SURVEY_TOKENS = new Set([...SEND_SURVEY_TOKENS, 'link']);

export const findUnsupportedTokens = text => {
    if (!text) return [];
    const matches = text.match(/\[([^\]]+)\]/g) || [];
    const offenders = matches.filter(m => !ALLOWED_SEND_SURVEY_TOKENS.has(m.slice(1, -1)));
    return Array.from(new Set(offenders));
};
